import styled from "styled-components"

export const StyledInput = styled.input`
  width: 130px;
  display: inline-block;
  -webkit-appearance: none;
  background: transparent;
  height: 30px;
  padding: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #00adee;
    cursor: pointer;
    margin-top: -7px;
    box-shadow: 0px 0px 0px 1px #666565;
    border: 2px solid #fff;
  }

  &::-ms-thumb {
    -webkit-appearance: none;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #00adee;
    cursor: pointer;
    margin-top: -7px;
    box-shadow: 0px 0px 0px 1px #666565;
    border: 2px solid #fff;
  }

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
    background: #666565;
  }

  &:focus::-webkit-slider-runnable-track {
    background: #666565;
  }

  &::-ms-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
    background: #666565;
  }
`
